import React, { useState, useCallback, ReactNode } from "react";

import { useOnOutsideClick } from "src/hooks/useOnOutsideClick";
import {
  dropdown,
  dropdownTitle,
  dropdownChildren,
} from "./Dropdown.module.less";

type Props = {
  title: string;
  children: ReactNode;
  className?: string;
  onClick: () => void;
};

const Dropdown = ({ title, children, className, onClick }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeDropdown = useCallback(() => {
    setIsOpen(false);
  }, []);

  const containerRef = useOnOutsideClick<HTMLDivElement>(closeDropdown);

  const handleOnClick = () => {
    onClick?.();
    setIsOpen(true);
  };

  return (
    <div className={`${dropdown} ${className || ""}`} ref={containerRef}>
      <button type="button" className={dropdownTitle} onClick={handleOnClick}>
        {title}
      </button>
      {isOpen && <div className={dropdownChildren}>{children}</div>}
    </div>
  );
};

export default Dropdown;
